import gql from 'graphql-tag';
import { useMutation } from 'react-apollo';
import { updateUserLog } from '../../graphql/mutations';

export function useUserLogFunctions(handleUserUpdate, user) {
  const [updateUserLogEntry] = useMutation(gql(updateUserLog), {
    update(cache, { data: { setUserLog } }) {
      if (!setUserLog) {
        console.error('setUserLog is undefined or null');
        return;
      }
      handleUserUpdate(setUserLog);
    },
  });

  const createLogEntry = async ({ eventName, details = {} }) => {
    const ts = new Date().toISOString();
    let existing = user?.userLog || {};
    if (typeof existing === 'string') {
      try { existing = JSON.parse(existing); } catch (_) { existing = {}; }
    }
    const existingLog = Array.isArray(existing.log) ? existing.log : [];
    let next = {
      ...existing,
      log: [...existingLog, { timestamp: ts, pageURL: typeof window !== 'undefined' ? window.location.href : undefined, eventName, details }],
    };
    await updateUserLogEntry({ variables: { userLog: next } });
  };

  const clearUserLog = async () => {
    let existing = user?.userLog || {};
    if (typeof existing === 'string') {
      try { existing = JSON.parse(existing); } catch (_) { existing = {}; }
    }
    const next = { ...existing, log: [] };
    await updateUserLogEntry({ variables: { userLog: next } });
  };

  return {
    createLogEntry,
    clearUserLog
  };
}
